module.exports = __webpack_public_path__ + "img/enterprise_banner4.8d271b38.png";